import React from 'react';
import styled from '@emotion/styled';
import { theme } from './layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Section } from './Section';
import { Flex } from './Flex';
import { Copy } from './Copy';
import { ButtonPrimary } from './layout/StyledComponents';
import { Title } from './Title';
import { Link } from 'gatsby';

const StyledDocHome = styled.div`
    > section {
        > div {
            align-items: center;
        }
    }
    .paragraph {
        font-size: 18px;
    }
    .image {
        margin-bottom: 16px;
        flex-shrink: 0;
        border-radius: 512px;
        border: 8px solid var(--dark-mode-yellow-1, #e4c96f);
        img {
            border-radius: 512px;
        }
    }
    @media ${theme.device.laptop} {
        .short-image {
            height: 700px;
        }
        .large-image {
            height: 700px;
            img {
                height: 900px;
            }
        }
    }
    @media ${theme.device.laptopL} {
        div {
            max-width: 1500px;
            margin: 0 auto;
        }

        .short-image {
            height: 620px;
            width: 500px;
        }
        .large-image {
            width: 40vw;
            max-width: 700px;

            img {
                height: 850px;
            }
        }
    }
`;

export const DocHome = ({ home }: { home?: boolean }) => {
    return (
        <StyledDocHome>
            <Section border background="red">
                <Flex equal gap={64}>
                    <StaticImage
                        className="image large-image"
                        src="../images/home/dr-mike-gordon.jpeg"
                        quality={80}
                        alt="Dr. Matthew Brauchemin"
                    />
                    <Copy>
                        <Title border position="left" color="red">
                            Michael Gordon, DDS
                        </Title>
                        <p className="paragraph">
                            Dr. Michael J. Gordon, Jr is a North Carolina native. Dr. Gordon
                            graduated high school in Fayetteville, NC then attended the United
                            States Naval Academy where he earned an Aerospace Engineering Bachelor
                            of Science degree while also completing his pre-dental courses. After
                            fulfilling his service to the U. S. Navy, Dr. Gordon earned his
                            Doctorate of Dental Surgery at the University of North Carolina in
                            Chapel Hill.
                        </p>
                        {home ? (
                            <ButtonPrimary solid color="red">
                                <Link to="/about-us/our-team/">More About Our Team</Link>
                            </ButtonPrimary>
                        ) : (
                            <></>
                        )}
                    </Copy>
                </Flex>
            </Section>
        </StyledDocHome>
    );
};
